import Controller from '@ember/controller';

import { AlmostReady } from 'register-partners-js/react/components/almost-ready';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class AlmostReadyController extends Controller {
  mainLayout = MainLayout;

  almostReady = AlmostReady;
}
